import UnPakt from '@/components/HomebuyerOffers/unpakt.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers/unpakt',
  name: RouteNames.UnPakt,
  component: UnPakt,
};

export default route;
